import { fetch as fetchPolyfill } from 'whatwg-fetch';
import { lotteryList } from './lottery-list';
import {
  CREATE_LOTTERY_ERROR,
  CREATE_LOTTERY_SUCCESS,
  REQUEST_DELETE_LOTTERIES,
  DELETE_LOTTERIES_ERROR,
  DELETE_LOTTERIES_SUCCESS,
  DELETE_LOTTERY_ERROR,
  DELETE_LOTTERY_SUCCESS,
  UPDATE_LOTTERY_ERROR,
  UPDATE_LOTTERY_SUCCESS,
  LOAD_LOTTERIES_SUCCESS,
  UNLOAD_LOTTERIES_SUCCESS,
  REQUEST_SELECT_WINNER,
  SELECT_WINNER_SUCCESS,
  SELECT_WINNER_ERROR,
  REQUEST_CLEAR_LOTTERIES,
  CLEAR_LOTTERIES_ERROR,
  CLEAR_LOTTERIES_SUCCESS,
  START_DRAM_ROLL,
  FINISH_DRAM_ROLL,
  FINISH_WIN_ANIMATION,
  SHOW_SNAK_BAR,
  HIDE_SNAK_BAR,
  UPDATE_NUMBER_OF_WINNER,
} from './action-types';

const selectWinnerAPI = `https://${
  process.env.REACT_APP_API_DOMAIN
}/selectWinner`;
const clearGameAPI = `https://${process.env.REACT_APP_API_DOMAIN}/clearGame`;
const clearLotteryAPI = `https://${
  process.env.REACT_APP_API_DOMAIN
}/clearLottery`;

function selectWinnerSuccess(payload) {
  return {
    type: SELECT_WINNER_SUCCESS,
    payload,
  };
}

function selectWinnerError(error) {
  return {
    type: SELECT_WINNER_ERROR,
    payload: error,
  };
}

function requestSelectWinner() {
  return {
    type: REQUEST_SELECT_WINNER,
  };
}

export function startDramRoll() {
  return {
    type: START_DRAM_ROLL,
  };
}

function finishDramRoll() {
  return {
    type: FINISH_DRAM_ROLL,
  };
}

export function startLottery(numberOfWinners) {
  return (dispatch, getState) => {
    const { auth } = getState();
    dispatch(finishDramRoll());
    dispatch(requestSelectWinner());
    fetchPolyfill(selectWinnerAPI, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        numberOfWinners,
        token: auth.id,
      }),
    })
      .then(res => res.json())
      .then(json => dispatch(selectWinnerSuccess(json)))
      .catch(error => {
        dispatch(selectWinnerError(error));
        setTimeout(() => {
          dispatch(hideSnakBar());
        }, 3000);
      });
  };
}

export function createLotteryError(error) {
  return {
    type: CREATE_LOTTERY_ERROR,
    payload: error,
  };
}

export function createLotterySuccess(lottery) {
  return {
    type: CREATE_LOTTERY_SUCCESS,
    payload: lottery,
  };
}

export function deleteLotteryError(error) {
  return {
    type: DELETE_LOTTERY_ERROR,
    payload: error,
  };
}

export function deleteLottery(lottery) {
  return dispatch => {
    lotteryList
      .remove(lottery.phone_number)
      .catch(error => dispatch(deleteLotteryError(error)));
  };
}

export function deleteLotterySuccess() {
  return {
    type: DELETE_LOTTERY_SUCCESS,
  };
}

function requestDeleteLotteris() {
  return {
    type: REQUEST_DELETE_LOTTERIES,
  };
}

export function deleteLotteriesSuccess(payload) {
  return {
    type: DELETE_LOTTERIES_SUCCESS,
    payload,
  };
}

export function deleteLotterisError(error) {
  return {
    type: DELETE_LOTTERIES_ERROR,
    payload: error,
  };
}

export function deleteLotteris() {
  return (dispatch, getState) => {
    const { auth } = getState();
    dispatch(requestDeleteLotteris());
    setTimeout(() => {
      fetchPolyfill(clearGameAPI, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          token: auth.id,
        }),
      })
        .then(res => res.json())
        .then(json => dispatch(deleteLotteriesSuccess(json)))
        .catch(error => dispatch(deleteLotterisError(error)));
    }, 2000);
  };
}

export function updateLotteryError(error) {
  return {
    type: UPDATE_LOTTERY_ERROR,
    payload: error,
  };
}

export function updateLottery(lottery, changes) {
  return dispatch => {
    lotteryList
      .update(lottery.phone_number, changes)
      .catch(error => dispatch(updateLotteryError(error)));
  };
}

export function updateLotterySuccess(lottery) {
  return {
    type: UPDATE_LOTTERY_SUCCESS,
    payload: lottery,
  };
}

export function loadLotteriesSuccess(lotteries) {
  return {
    type: LOAD_LOTTERIES_SUCCESS,
    payload: lotteries,
  };
}

export function loadLotteries() {
  return (dispatch, getState) => {
    const { auth } = getState();
    lotteryList.path = `phones/${auth.id}`;
    lotteryList.subscribe(dispatch);
  };
}

export function unloadLotteries() {
  lotteryList.unsubscribe();
  return {
    type: UNLOAD_LOTTERIES_SUCCESS,
  };
}

function requestClearLotteris() {
  return {
    type: REQUEST_CLEAR_LOTTERIES,
  };
}

export function clearLotterisError(error) {
  return {
    type: CLEAR_LOTTERIES_ERROR,
    payload: error,
  };
}

export function clearLotteriesSuccess(payload) {
  return {
    type: CLEAR_LOTTERIES_SUCCESS,
    payload,
  };
}
export function clearLotteris() {
  return (dispatch, getState) => {
    const { auth } = getState();
    dispatch(requestClearLotteris());
    setTimeout(() => {
      fetchPolyfill(clearLotteryAPI, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          token: auth.id,
        }),
      })
        .then(res => res.json())
        .then(json => dispatch(clearLotteriesSuccess(json)))
        .catch(error => dispatch(clearLotterisError(error)));
    }, 2000);
  };
}

export function finishedWinAnimation() {
  return {
    type: FINISH_WIN_ANIMATION,
  };
}

export function showAndHideSnackBar(message, limit = 2000) {
  return dispatch => {
    dispatch(showSnackBar(message));
    setTimeout(() => {
      dispatch(hideSnakBar());
    }, limit);
  };
}

export function showSnackBar(message) {
  return {
    type: SHOW_SNAK_BAR,
    payload: { message },
  };
}

export function hideSnakBar() {
  return {
    type: HIDE_SNAK_BAR,
  };
}

export function updateNumberOfWinner(numberOfWinner) {
  return {
    type: UPDATE_NUMBER_OF_WINNER,
    payload: { numberOfWinner },
  };
}



// WEBPACK FOOTER //
// ./src/core/lotteries/actions.js